export async function resizeImage(file, width, height) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => (blob ? resolve(blob) : reject(new Error('Canvas is empty'))),
          file.type,
          0.95
        );
      };
      img.src = e.target?.result;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function uploadImageToMultipleSizes({
  file,
  sizes,
  containerClient,
  contentType,
}) {
  const uploads = sizes.map(async ({ path, width, height }) => {
    let blobData = file;

    if (width && height) {
      blobData = await resizeImage(file, width, height);
    }

    const blobName = `${path}${file.name}`;
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);

    await blockBlobClient.uploadData(blobData, {
      blobHTTPHeaders: { blobContentType: contentType },
    });
  });

  await Promise.all(uploads);
}
